import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import getCustomSIPHeaderByID from 'API/CustomSIPHeaders/getCustomSIPHeaderByID';

const useGetCustomSIPHeaderByID = (
    headerId,
    setFormData,
    setInitialFormData,
) => {
    const { currentScope } = useSelector((state) => state.login);

    return useQuery({
        queryKey: ['customSIPHeader', headerId],
        queryFn: async () => {
            try {
                const data = await getCustomSIPHeaderByID(
                    headerId,
                    currentScope,
                ).then((res) => {
                    setFormData(res);
                    setInitialFormData(res);
                    return res;
                });
                return data;
            } catch (error) {
                console.error('Error fetching custom SIP header:', error);
                throw error;
            }
        },
        refetchOnWindowFocus: false,
        enabled: !!headerId,
        staleTime: 0,
    });
};

export default useGetCustomSIPHeaderByID;
